export default __webpack_public_path__ + "static/media/bg_2.a4df66c9.png";